export const SignUpPage = (destinationLang) => {
  return [
    {
      FormKey: "sign-up-navbar-title",
      Key: "ثبت نام",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "signup-alert-sms-sent",
      Key: "پیامک با موفقیت ارسال شد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "signup-input-national-code-passport-id",
      Key: "کدملی / شماره پاسپورت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "signup-input-email",
      Key: "پست الکترونیک",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "sign-up-input-repeat-password",
      Key: "تکرار رمز",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-link-terms-conditions",
      Key: "قوانین و شرایط",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-checkbox-terms-conditions",
      Key: "را می پذیرم",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-radio-btn-Iranian",
      Key: "ایرانی",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-radio-btn-foreigner",
      Key: "غیر ایرانی",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-label-auth-code-enter-hint",
      Key: "کد ارسال شده را وارد نمایید",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-btn-resend-otp",
      Key: "ارسال مجدد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-alert-fill-empty",
      Key: "فیلد های خالی را پر کنید",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-alert-password-mismatch",
      Key: "گذروازه ها تطابق ندارند",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "sign-up-btn-get-sms-verification",
      Key: "دریافت کد احراز هویت",
      DistinitationLanguage: destinationLang,
    },
  ];
};
